// extracted by mini-css-extract-plugin
export default {"userInfo":"UOBy2zAW","avatar":"BL0_aSqI","name":"l_4pX2K6"};